export default {
    h1: 'How to invite？',
    bgImg: 'https://web-data.zmlearn.com/image/3XebfjovWqkgEQiQnvLZe6/img_invite.png',
    left: [{
        i: '01',
        span: 'Tell a friend about AirClass',
        links: ['Our tutors', 'How it works', 'Become a tutor', 'APP download']
    }, {
        i: '02',
        span: 'Share AirClass',
        spans: ['Share on Facebook', 'Send Invitations', 'Share Your Link']
    }, {
        i: '03',
        span: 'Invite friends, get rewards!',
        p: 'Earn $10 for trial lessons and $100 for paid lessons!'
    },],
    right: {
        h1: 'Get bonuses for each friend you bring to AirClass',
        desc: 'Once your friend is signed up: ',
        content: `if he or she attends the trial lessons,
        you will earn <strong>$10 maximum</strong>;
        if he or she pays for our lessons,
        you will earn <strong>$100 maximum</strong>.`,
        fb_btn: 'Share on Facebook',
        or: 'OR',
        send: 'Send Invitations',
        link: 'Share Your Personal Link',
        history: 'Referral History',
        copied: 'Copied',
        copy: 'Copy',
    },
    modal: {
        span1: 'Trial Lesson Attendance',
        span2: 'Valid Payment',
        span3: 'Awards Earned',
        li: 'You have not invited any friends',
    },
    alert: {
        warn1: 'Please add at least one recipient.',
        warn2: 'Please enter the correct email format',
        success: 'Thanks! We’ve send you the referral email.',
        success1: 'Copy success',
    }
}